module.exports = __webpack_public_path__ + "img/table-8.57fd2fe4.jpg";